import { Link } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";
import EllipsisText from "components/EllipsisText";
import {
  filter_worker_invitation_user_types,
  getWorkerInvitationUserType,
} from "helpers/options/worker_invitation_user_types";

const columns = [
  {
    title: "Imię",
    dataIndex: "first_name",
    sortable: true,
    searchable: true,
    search_method: "matches",
    render: (_, { id, first_name }) => (
      <Link to={`/worker_invitations/${id}`}>
        <EllipsisText text={first_name} limit={20} /> <EditOutlined />
      </Link>
    ),
  },
  {
    title: "Nazwisko",
    dataIndex: "last_name",
    sortable: true,
    searchable: true,
    search_method: "matches",
    render: (_, { last_name }) => <EllipsisText text={last_name} limit={20} />,
  },
  {
    title: "E-mail",
    dataIndex: "email",
    sortable: true,
    searchable: true,
    search_method: "matches",
    render: (_, { email }) => <EllipsisText text={email} limit={50} />,
  },
  {
    title: "Typ",
    dataIndex: "user_type",
    sortable: true,
    searchable: true,
    search_method: "in",
    search_component: "select",
    options: filter_worker_invitation_user_types,
    render: (_, { id, user_type }) => getWorkerInvitationUserType(user_type),
  },
];

export default columns;
